const API_URL = process.env.REACT_APP_API_URL || "http://localhost:5000/api";
export const API_BASE =
  process.env.REACT_APP_API_BASE || "http://localhost:5000";

// ── Generic fetch wrapper ─────────────────────────────────────────────────────
async function apiFetch(path, options = {}) {
  const res = await fetch(`${API_URL}${path}`, {
    headers: { "Content-Type": "application/json" },
    ...options,
  });
  if (!res.ok) throw new Error(`API error: ${res.status}`);
  return res.json();
}

// ── Settings ──────────────────────────────────────────────────────────────────
export const fetchSettings = () => apiFetch("/settings");

// ── Categories ────────────────────────────────────────────────────────────────
export const fetchCategories = () => apiFetch("/categories");

// ── Brands ────────────────────────────────────────────────────────────────────
export const fetchBrands = (params = {}) => {
  const qs = new URLSearchParams(
    Object.fromEntries(
      Object.entries(params).filter(
        ([, v]) => v !== "" && v !== null && v !== undefined,
      ),
    ),
  ).toString();
  return apiFetch(`/brands${qs ? `?${qs}` : ""}`);
};
export const fetchBrand = (slug) => apiFetch(`/brands/${slug}`);

// ── Blogs ─────────────────────────────────────────────────────────────────────
export const fetchBlogs = (params = {}) => {
  const qs = new URLSearchParams(
    Object.fromEntries(
      Object.entries(params).filter(
        ([, v]) => v !== "" && v !== null && v !== undefined,
      ),
    ),
  ).toString();
  return apiFetch(`/blogs${qs ? `?${qs}` : ""}`);
};
export const fetchBlog = (slug) => apiFetch(`/blogs/${slug}`);

// ── Testimonials ──────────────────────────────────────────────────────────────
export const fetchTestimonials = () => apiFetch("/testimonials");

// ── FAQs ──────────────────────────────────────────────────────────────────────
export const fetchFAQs = () => apiFetch("/faqs");

// ── Contact ───────────────────────────────────────────────────────────────────
export const submitContact = (data) =>
  apiFetch("/contact", {
    method: "POST",
    body: JSON.stringify(data),
  });

// ── Image URL helper ──────────────────────────────────────────────────────────
export const imgUrl = (path) => (path ? `${API_BASE}${path}` : null);
